import { call, select, takeLatest } from 'redux-saga/effects';
import {
  GlobalAction,
  GlobalActions,
  GlobalPut,
  VorversicherungChanged,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { isGebaeudeYoungerThanFiveYears } from '../../app/shared/selectors/gebaeude.selector';

export function* watchVorversicherungVorhandenChanged() {
  yield takeLatest(
    GlobalActions.VORVERSICHERUNG_VORHANDEN_CHANGED,
    safeSaga(updateAppAndTarifiere, App.VWG),
  );
}

export function* updateAppAndTarifiere(action: GlobalAction<VorversicherungChanged>) {
  const state: IAppState = yield select();
  if (
    action.payload.appId === App.VWG &&
    action.payload.angebotsId === state.angebotsId &&
    !isGebaeudeYoungerThanFiveYears(state.gebaeude.baujahr)
  ) {
    const globalPut = GlobalPut.getInstance();
    yield call(globalPut.put, new GlobalActions().tarifiereShopSync(action));
  }
}
